// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"8720b37a","817":"91071609"}[chunkId] + ".chunk.js";
};